import { Component } from '@angular/core';


import {
    NavController, AlertController, ToastController, MenuController, LoadingController,
    Events
} from "ionic-angular";

import { UserData } from '../../providers/user-data';

import { UserOptions } from '../../interfaces/user-options';

import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';

import { TabsPage } from '../tabs-page/tabs-page';
import { MissionsListPage } from '../missions/missions-list/missions-list'
import { SignupPage } from '../signup/signup';
import {AuthService} from "../../services/auth";
import {AngularFireAuth} from "angularfire2/auth";


@Component({
    selector: 'page-user',
    templateUrl: 'login.html'
})
export class LoginPage {
    public static readonly pageName = "LoginPage";

    login: UserOptions = { username: '', password: '' };
    submitted = false;
    error: boolean = false;
    errorMessage: string = "";
    loginForm : FormGroup;
    submitAttempt: boolean = false;
    loading: any = false;
    sessionRef: any;
    userRef: any;


    constructor(
        public navCtrl: NavController,
        public userData: UserData,
        public alertCtrl: AlertController,
        public menu: MenuController,
        public toastCtrl: ToastController,
        public angularFireAuth: AngularFireAuth,
        public authService: AuthService,
        private formBuilder: FormBuilder,
        public loadingCtrl: LoadingController,
        public events: Events

    )
    {
        this.loginForm = this.formBuilder.group({
            username: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]],
        });
    }
    trimEmail()
    {
        var username = this.login.username;
        username = username.replace(' ','');
        this.login.username = username.trim();
    }
    setLoading(state){
        if(state)
        {
            this.loading = this.loadingCtrl.create({
                content: 'Connexion ...'
            });
            this.loading.present();
        }
        else if(this.loading){
            this.loading.dismiss();
        }
    }

    onLogin(form: NgForm) {
        var that = this;
        this.submitted = true;

        if (form.valid) {
            this.setLoading(true);
            this.userData.login(this.login.username,this.login.password).then(value => {

                //this.navCtrl.push(MissionsListPage);
                //this.userData.checkLoggedInRootPage();
                //that.userData.checkLoggedInRootPage(this.navCtrl);
                /*setTimeout(function(){
                    that.setLoading(false);
                    if(!that.navCtrl.getActive() || (that.navCtrl.getActive() && that.userData.anonymousPages.indexOf(that.navCtrl.getActive().id)>=0))
                    {
                        that.navCtrl.setRoot(that.userData.loggedInDestination());
                    }
                },1000);*/
                that.setLoading(false);

            })
            .catch(err => {
                this.setLoading(false);

                that.error = true;
                that.errorMessage = "Identifiant ou mot de passe incorrect.";
            });

        }
    }
    ionViewDidEnter() {

        this.getUserInfos();
    }
    ionViewDidLoad() {

       // this.getUserInfos();
    }
    ionViewWillLeave() {
        //console.log("Login page will unload");
        //this.sessionRef.unsubscribe();
        //this.userRef.unsubscribe();
    }
    getUserInfos() {
        var that = this;
        that.userData.hasLoggedIn().then(function(logged){
                if(logged)
                {
                    that.events.publish('app:checkroot');
                }
            });
        /*if(!that.sessionRef || that.sessionRef.closed) {
            that.sessionRef = that.userData.userSession().subscribe(session => {
                if (session !== null) {
                    //that.navCtrl.setRoot(MissionsListPage);

                }
            });
        }*/
    }
    onSignup() {
        this.navCtrl.push(SignupPage);
    }
    forgotPass() {
        var that = this;
        let forgot = this.alertCtrl.create({
            title: 'Mot de passe perdu ?',
            message: "Pour recevoir les instructions par email, saisissez votre adresse email et validez.",
            inputs: [
                {
                    name: 'email',
                    placeholder: 'Email',
                    type: 'email'
                },
            ],
            buttons: [
                {
                    text: 'Annuler',
                    handler: data => {

                    }
                },
                {
                    text: 'Envoyer',
                    handler: data => {

                        that.angularFireAuth.auth.sendPasswordResetEmail(data.email)
                            .then(function(ret){

                                var message = "Un email vous a été envoyé à l'adresse : "+data.email+"<br/><br/>Cliquez sur le lien qu'il contient pour réinitialiser votre mot de passe.";
                                let success = that.alertCtrl.create({
                                    title: 'Email envoyé',
                                    message: message,
                                    buttons: [
                                        {
                                            text: 'Ok',
                                        }
                                    ]
                                });
                                success.present();
                            })
                            .catch(err => {

                                var message = "Une erreur s'est produite "+err.code;
                                if(err.code == "auth/invalid-email")
                                {
                                    message = "L'adresse email fournie n'est pas une adresse email valide.";
                                }
                                else if(err.code == "auth/user-not-found")
                                {
                                    message = "Cette adresse email n'est pas enregistrée sur Novaterim. Essayez de vous inscrire.";
                                }
                                let error = that.alertCtrl.create({
                                    title: 'Erreur',
                                    message: message,
                                    buttons: [
                                        {
                                            text: 'Ok',
                                        }
                                    ]
                                });
                                error.present();
                            });
                    }
                }
            ]
        });
        forgot.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts